export const MessageLevel = {
  Error: 0,
  Warning: 1,
  Info: 2
};
